import React, { useContext, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Formik, Form } from 'formik'
import TextField from '@material-ui/core/TextField'

import NeedHelp from '../../components/need-help'
import RenderError from '../../components/render-error'

import initialValues from '../../data/initialValues'
import validation from '../../validation/payment'
import DonationFormContext from '../../context/donation'
import { setSS, getSS, cleanObject, loadIndexPage } from '../../helpers'
import { saveDonation } from '../../api'

const PaymentRegular: React.FC = (props: any) => {

  const navigate = useNavigate()
  const params = useParams()
  const donationForm = useContext(DonationFormContext)
  const appeal = (window as any).KEW.collections.appeal[0]
  const url = params.url
  let donation = getSS('donation')

  if (donation.amount === undefined || donation.process_payment) {
    donation = undefined
    loadIndexPage(navigate, url)
  }

  useEffect(() => {
    document.title = 'Bank details - ' + (window as any).KEW.collections.appeal[0].meta_page_title
  })

  useEffect(() => {
    document.body.classList.add('landing')
    document.body.style.backgroundImage = `url(${appeal.landing_page_background})`
  })

  const onSubmit = async (data: any) => {
    console.log(data);

    donationForm.showLoading()

    // store a redacted version of account number
    donation.bank_account_number_redacted = data.bank_account_account_number.replace(/^.{4}/g, 'xxxx');
    donation.bank_account_account_name = data.bank_account_account_name
    donation.bank_account_account_number = data.bank_account_account_number
    donation.bank_account_sort_code = data.bank_account_sort_code
    // show loading
    // (window as any).scrollTo(0, 0);
    // donationForm.showLoading()
    // donationForm.hideLoading()
    donation.process_payment = true;
    donation.bacs_sun = (window as any).KEW.globals.bacs_sun;
    if (donation.optins_giftaid) {
      donation.giftaid_amount = (donation.amount * 0.25).toFixed(2);
    }

    console.log(donation);
    const savedDonation: any = await saveDonation(donation)
    if (savedDonation?.status === 200) {
      donation = savedDonation.data
      setSS('donation', donation);
      donationForm.hideLoading()
      navigate(`/donate/${url}/thanks`)
    } else {
      alert('something went wrong saving the donation!')
      donationForm.hideLoading()
      navigate(`/donate/${url}/failed`)
    }

  }

  return (
    <>
      { donation &&
        <>
          <Formik
            initialValues={ initialValues.payment_regular }
            validationSchema={ validation.payment_regular }
            enableReinitialize
            onSubmit={onSubmit}>
            {(props) => {
              props.errors = cleanObject(props.errors)
              return (
                <Form name="donationForm">
                  <div className="row intro">
                    <div className="large-12 columns box">
                      <div className="intro-copy">
                        <h1>Direct Debit details</h1>
                      </div>
                    </div>
                  </div>
                  <div className="row intro-divider"></div>
                  <div className="row">
                    <div className="direct-debit clearfix box">
                      <div className="large-12 columns"></div>

                      <div className="dd-fields clearfix">
                        <div className="large-12 columns text-center">
                          <p>I confirm that I am the account holder and I can authorise Direct Debits on this account.</p>
                          <p>Your donations will be collected on the 21st day of each month. The timing of your first donation will depend on the date you're filling in this form, as it takes about 20 days to process your Direct Debit and set everything up.</p>

                        </div>
                        <div className="large-12 columns donation-amount">
                          <label>Donation amount: {(getSS('donation').amount).toFixed(2)} per month</label>

                        </div>
                        <fieldset>
                          <legend>Your bank details</legend>
                          <div className="large-6 columns">
                            <h2>&nbsp;</h2>
                            <div className="input-container">
                              <TextField
                                type="text"
                                variant="outlined"
                                id="account-holder"
                                name="bank_account_account_name"
                                label="Name of account holder"
                                autoComplete="cc-name"
                                inputProps={{
                                  "aria-describedby": "account-holder_error"
                                }}
                                error={props.errors.bank_account_account_name ? true : false}
                                value={props.values.bank_account_account_name}
                                onChange={props.handleChange} />
                              <RenderError name="bank_account_account_name" id="account-holder_error" {...props} />
                              {/* <label htmlFor="account-holder">Name of account holder</label>
                              <input type="text" id="account-holder" name="bank_account_account_name" autoComplete="cc-name" /> */}
                              {/* span.error ng-if="showErrors && donationForm.bank_account_account_name.$error.sepiaValidation && !donationForm.bank_account_account_name.$focused" {{sepiaFormErrors['donation.bank_account_account_name']}}
                                span.error ng-if="showErrors && account_name_error" Please enter the name of the account holder */}
                            </div>
                          </div>
                          <div className="large-6 columns clear">
                            <div className="input-container">
                              <TextField
                                type="tel"
                                variant="outlined"
                                id="account-number"
                                name="bank_account_account_number"
                                label="Bank/building society account number"
                                autoComplete="cc-number"
                                inputProps={{
                                  "aria-describedby": "account-number_error"
                                }}
                                error={props.errors.bank_account_account_number ? true : false}
                                value={props.values.bank_account_account_number}
                                onChange={props.handleChange} />
                              <RenderError name="bank_account_account_number" id="account-number_error" {...props} />
                              {/* <label htmlFor="account-number" className="form pre">Bank/building society account number</label>
                              <input type="tel" id="account-number" name="bank_account_account_number" autoComplete="cc-number" /> */}
                              {/* span.error ng-if="showErrors && account_number_error" Please enter the account number
                                span.error ng-if="showErrors && donationForm.bank_account_account_number.$error.sepiaValidation && !donationForm.bank_account_account_number.$focused" {{sepiaFormErrors['donation.bank_account_account_number']}} */}
                            </div>
                          </div>
                          <div className="large-6 columns left">
                            <div className="input-container">
                              <TextField
                                type="tel"
                                variant="outlined"
                                id="sort-code"
                                name="bank_account_sort_code"
                                label="Branch sort code"
                                inputProps={{
                                  "aria-describedby": "sort-code_error"
                                }}
                                error={props.errors.bank_account_sort_code ? true : false}
                                value={props.values.bank_account_sort_code}
                                onChange={props.handleChange} />
                              <RenderError name="bank_account_sort_code" id="sort-code_error" {...props} />
                              {/* <label htmlFor="sort-code" className="form">Branch sort code</label>
                              <input type="tel" id="sort-code" name="bank_account_sort_code" /> */}
                              {/* span.error ng-if="showErrors && sort_code_error" Please enter the sort code
                                span.error ng-if="showErrors && donationForm.bank_account_sort_code.$error.sepiaValidation && !donationForm.bank_account_sort_code.$focused" {{sepiaFormErrors['donation.bank_account_sort_code']}} */}
                            </div>
                          </div>
                        </fieldset>
                        {/* <div className="large-12 columns">
                          <div className="input-container">
                            <span className="error">Invalid bank details, please check your account number and sort code and try again</span>
                          </div>
                        </div> */}
                      </div>
                      {getSS('donation').payment_type === 'Regular' &&
                        <div className="ddGuarantee box clearfix">
                          <div className="large-12 columns">
                            <p>The Royal Botanic Gardens, Kew will set up a Direct Debit from the account detailed in this instruction subject to the safeguards assured by the Direct Debit Guarantee.</p>
                            <span className="icon-dd-logo"></span>
                            <h2 className="dd">The Direct Debit Guarantee</h2>
                            <ul className="list">
                              <li>This Guarantee is offered by all banks and building societies that accept instructions to pay Direct Debits.</li>
                              <li>If there are any changes to the amount, date or frequency of your Direct Debit Royal Botanic Gardens, Kew will notify you 5 working days in advance of your account being debited or as otherwise agreed. If you request Royal Botanic Gardens, Kew to collect a payment, confirmation of the amount and date will be given to you at the time of the request.</li>
                              <li>If an error is made in the payment of your Direct Debit, by Royal Botanic Gardens, Kew or your bank or building society you are entitled to a full and immediate refund of the amount paid from your bank or building society. If you receive a refund you are not entitled to, you must pay it back when Royal Botanic Gardens, Kew asks you to.</li>
                              <li>In the event Royal Botanic Gardens, Kew are unsuccessful collecting a payment, we may attempt a second collection within 31 days.</li>
                              <li>You can cancel a Direct Debit at any time by simply contacting your bank or building society. Written confirmation may be required. Please also notify us on +44 (0)208 332 3248.</li>
                            </ul>
                          </div>
                        </div>
                      }
                      <div className="actions clearfix">
                        <div className="medium-6 columns">
                          <button type="submit" id="next-button-step2-monthly" className="btn-cta go" tabIndex={0}>Set up monthly gift</button>
                          <button type="button" id="back-button-step2-monthly" className="btn-cta back" tabIndex={0} onClick={() => navigate(-1)} onKeyPress={() => navigate(-1)}> Back</button>
                        </div>
                        <div className="medium-6 columns">
                          <div className="mobile-divider show-for-small-only"></div>
                          <NeedHelp />
                        </div>
                      </div>
                    </div>
                  </div>
                </Form>
              )
            }}
          </Formik>
        </>
      }
    </>
  )
}

export default PaymentRegular